(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["choiceSection"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('load', videoScroll);
  window.addEventListener('scroll', videoScroll);

  function videoScroll() {

    if ( document.querySelectorAll('video[loop]').length > 0) {
      var windowHeight = window.innerHeight,
          videoEl = document.querySelectorAll('video[loop]');

      for (var i = 0; i < videoEl.length; i++) {

        var thisVideoEl = videoEl[i],
            videoHeight = thisVideoEl.clientHeight,
            videoClientRect = thisVideoEl.getBoundingClientRect().top;

        if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
          thisVideoEl.play();
          // console.log("video playing");
        } else {
          thisVideoEl.pause();
          // console.log("video is not playing");
        }

      }
    }

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let downloadButton = document.getElementById('download');

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      downloadButton.setAttribute(
        'href',
        'https://play.google.com/store/apps/details?id=com.viatek.fitnation.echelon_android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
      );
    } else if (/android/i.test(userAgent)) {
      downloadButton.setAttribute(
        'href',
        'https://play.google.com/store/apps/details?id=com.viatek.fitnation.echelon_android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
      );
    }

    // iOS detection
    else if (/Mac|iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      downloadButton.setAttribute('href', 'https://apps.apple.com/us/app/echelon-fitness/id1262424186');
    } else {
      downloadButton.setAttribute(
        'href',
        'https://play.google.com/store/apps/details?id=com.viatek.fitnation.echelon_android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membershipSection"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('load', videoScroll);
  window.addEventListener('scroll', videoScroll);

  function videoScroll() {

    if ( document.querySelectorAll('video[loop]').length > 0) {
      var windowHeight = window.innerHeight,
          videoEl = document.querySelectorAll('video[loop]');

      for (var i = 0; i < videoEl.length; i++) {

        var thisVideoEl = videoEl[i],
            videoHeight = thisVideoEl.clientHeight,
            videoClientRect = thisVideoEl.getBoundingClientRect().top;

        if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
          thisVideoEl.play();
          // console.log("video playing");
        } else {
          thisVideoEl.pause();
          // console.log("video is not playing");
        }

      }
    }

  }

  } catch(e) { console.error(e); }
})();
})();
